import { useSafeAreaInsets } from "react-native-safe-area-context";
import { FindifyTopBarOverlay } from "./components/FindifyTopBarOverlay";
import { PlaceText } from "./components/PlaceText";

export const ScanRATab = ({ navigation }: any) => {
    const insets = useSafeAreaInsets();

    return (<>
        <FindifyTopBarOverlay />
        <PlaceText>ScanRATab</PlaceText>
    </>);
};
